<template>
    <g>
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M20.969 8.5H25C26.1046 8.5 27 9.39543 27 10.5V23.5C27 24.6046 26.1046 25.5 25 25.5H7C5.89543 25.5 5 24.6046 5 23.5V10.5C5 9.39543 5.89543 8.5 7 8.5H11.0309C11.277 6.52684 12.9602 5 15 5H17C19.0398 5 20.723 6.52684 20.969 8.5ZM25 10.5V14.3555H21.5V13.1055H19.5V14.3555H12.5V13.1055H10.5V14.3555H7V10.5L25 10.5ZM13.063 8.5C13.285 7.63739 14.0681 7 15 7H17C17.9319 7 18.715 7.63739 18.937 8.5L13.063 8.5ZM25 23.5V16.3555H21.5V17.6055H19.5V16.3555H12.5V17.6055H10.5V16.3555H7L7 23.5H25Z"
        />
    </g>
</template>
